import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Box, LinearProgress } from '@mui/material';
import deepmerge from 'deepmerge';

import useNotification from '../../../core/hooks/use_notification';
import { getCustomersNotificationData } from '../../../core/utils/notification_utils';
import { getDefaultPaginationByIdQueryValues } from '../../../core/utils/api_utils';
import PaginationControls from '../../common/pagination_controls';
import { getCustomersAction, getCustomersState } from '../../../features/customer/get_customers';
import CustomersList from './customers_list';
import CustomerFilters from './customer_filters';
import PageHeader from '../../common/page_header';

const initialQueryParams = {
    ...getDefaultPaginationByIdQueryValues,
    status: '',
    queryFilter: '',
    queryValue: ''
};

const CustomersPage = () => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const location = useLocation();

    const getCustomers = useSelector(getCustomersState);

    const [queryParams, setQueryParams] = useState(location?.state?.queryParams || initialQueryParams);

    const refreshList = useCallback(() => {
        if (queryParams?.queryFilter && !queryParams?.queryValue) return;

        dispatch(getCustomersAction(queryParams))
            .then(response => showErrorMessage(getCustomersNotificationData(response)));
    }, [dispatch, queryParams, showErrorMessage]);

    useEffect(() => {
        refreshList();
    }, [refreshList]);

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>

            <PageHeader title="Użytkownicy"/>

            <CustomerFilters
                queryParams={ queryParams }
                setQueryParams={ setQueryParams }
            />

            { getCustomers?.loading && (
                <Box sx={ { width: '100%' } }>
                    <LinearProgress/>
                </Box>
            ) }

            { getCustomers?.data?.content && (
                <Box sx={ { display: 'flex', flexDirection: 'column', gap: 2 } }>
                    <CustomersList queryParams={ queryParams }/>

                    <Box sx={ { display: 'flex', justifyContent: 'flex-end', mt: 1 } }>
                        <PaginationControls
                            currentPage={ getCustomers?.data?.pageable?.pageNumber }
                            totalPages={ getCustomers?.data?.totalPages }
                            setPage={ page => setQueryParams(prevState => deepmerge(prevState, { page })) }
                        />
                    </Box>
                </Box>
            ) }

        </Box>
    );
};

export default CustomersPage;